import queryString from "query-string";

/**
 * @param baseSearchPath - querystring part of a URL needed to parse (Example: window.location.search for client apps)
 * @param targetPath - target path
 * @param queryParamsArrayToTransfer - query params that need's to be transferred
 * @returns {string} result url
 */
export function transferSearchQueryParams(baseSearchPath, targetPath, queryParamsArrayToTransfer) {
    const parsedBase = queryString.parse(baseSearchPath);
    const  queryParamsDict = {};
    for (const queryParam of queryParamsArrayToTransfer) {
        let currentQueryValue = parsedBase[queryParam];
        if (currentQueryValue) {
            queryParamsDict[queryParam] = currentQueryValue;
        }
    }
    return queryString.stringifyUrl({url: targetPath, query: queryParamsDict})
}

/**
 * @param baseUrlPath -  entire URL needed to parse (Example: window.location.href for client apps)
 * @param targetPath - target path
 * @param queryParamsArrayToTransfer - query params that need's to be transferred
 * @returns {string} result url
 */
export function transferUrlQueryParams(baseUrlPath, targetPath, queryParamsArrayToTransfer) {
    const parsedBase = queryString.parseUrl(baseUrlPath);
    const  queryParamsDict = {};
    for (const queryParam of queryParamsArrayToTransfer) {
        let currentQueryValue = parsedBase.query[queryParam];
        if (currentQueryValue) {
            queryParamsDict[queryParam] = currentQueryValue;
        }
    }
    return queryString.stringifyUrl({url: targetPath, query: queryParamsDict})
}



// WEBPACK FOOTER //
// ./src/utils/urlUtils.js